import React from 'react'
import { useTranslation } from 'react-i18next'
import { FallbackProps } from 'react-error-boundary'
import { Button } from '@pandiafi/design-system'
import { useNavigate } from 'react-router-dom'

import { Error } from 'components/Error'
import { useContractPaths } from 'hooks/useContractPaths/useContractPaths'
import { ResidentAppErrorBoundary } from 'components/ResidentAppErrorBoundary/ResidentAppErrorBoundary'

interface ErrorHandlerProps {
  children: React.ReactNode
}

export const ErrorHandler: React.FC<ErrorHandlerProps> = ({ children }) => {
  const { t } = useTranslation(['common', 'bulletins'])
  const navigate = useNavigate()
  const { frontPagePath } = useContractPaths()

  const fallbackRender = ({ resetErrorBoundary }: FallbackProps) => {
    const action = (
      <Button
        onClick={() => {
          resetErrorBoundary()
          navigate(frontPagePath)
        }}
      >
        {t('common:views.home')}
      </Button>
    )

    return (
      <Error
        title={t('common:views.bulletinBoard')}
        message={t('bulletins:errors.bulletinsFetchError')}
        illustration="house-unhappy"
        action={action}
      />
    )
  }

  return (
    <ResidentAppErrorBoundary fallbackRender={fallbackRender}>
      {children}
    </ResidentAppErrorBoundary>
  )
}
